import { ComponentPropsWithoutRef, forwardRef } from "react";

import classNames from "classnames";

import styles from "./StyledAutoSizer.module.scss";

/**
 * A hidden measurement surface used by the auto-sizing text area.
 */
export type StyledAutoSizerProps = ComponentPropsWithoutRef<"div">;

export const StyledAutoSizer = forwardRef<HTMLDivElement, StyledAutoSizerProps>(function StyledAutoSizer(
  { className, ...props },
  ref,
) {
  return <div {...props} className={classNames(styles.AutoSizer, className)} ref={ref} />;
});
